<ng-template #paymentMethodContent>
  <div class="payment-method-card">
    <ng-template #invoiceUnavailableWarning>
      <div class="warning-box" *ngIf="showInvoiceUnavailableWarning">
        <span class="mdn-Icon-circulo-exclamacao mdn-Icon--md warning-icon"></span>
        <div class="warning-content">
          <p class="warning-text">{{ 'pages.paymentMethod.invoiceUnavailableWarning' | i18n }}</p>
          <ul class="warning-product-list" *ngIf="invoiceUnavailableProducts.length > 0">
            <li *ngFor="let product of invoiceUnavailableProducts">{{ product }}</li>
          </ul>
        </div>
      </div>
    </ng-template>

    <!-- Estado de visualização -->
    <div *ngIf="!isEditing" class="pi-container">
      <div class="pi-payment-item">
        <div class="pi-config-header">
          <div class="pi-config-title">
            <p class="payment-method-card-label">{{ 'pages.paymentMethod.description' | i18n }}</p>
            <p class="pi-label-value">{{ getSelectedPaymentMethodLabel() }}</p>
          </div>
          <div class="pi-actions">
            <button type="button" class="pi-edit-btn" (click)="editPayment()">{{ 'pages.paymentMethod.editButton' | i18n }}</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Estado de edição -->
    <div *ngIf="isEditing" class="pi-edit-mode">
      <ng-container *ngTemplateOutlet="invoiceUnavailableWarning"></ng-container>

      <p class="payment-method-card-description">{{ 'pages.paymentMethod.description' | i18n }}</p>
      <section class="payment-method-section">
        <div class="radio-group payment-type-radio">
          <label class="radio-option">
            <input
              type="radio"
              name="invoicePaymentType"
              value="boleto_cartao"
              [checked]="invoicePaymentType === 'boleto_cartao'"
              (change)="onInvoicePaymentTypeChange('boleto_cartao')"
              class="radio-input"
            />
            <span class="radio-label">{{ 'pages.paymentMethod.options.boletoCredit' | i18n }}</span>
          </label>
          <label class="radio-option">
            <input
              type="radio"
              name="invoicePaymentType"
              value="minha_conta"
              [checked]="invoicePaymentType === 'minha_conta'"
              [disabled]="disableInvoiceOption"
              (change)="onInvoicePaymentTypeChange('minha_conta')"
              class="radio-input"
            />
            <span class="radio-label">{{ 'pages.paymentMethod.options.invoice' | i18n }}</span>
          </label>
        </div>
      </section>

      <div class="pi-config-actions">
        <button 
          type="button" 
          class="btn-outline" 
          *ngIf="isLastStep && isEditing; else backButton"
          (click)="cancelEdit()">
          {{ 'shared.buttons.cancel' | i18n }}
        </button>
        <ng-template #backButton>
          <button type="button" class="btn-outline" (click)="previousStep.emit()">{{ 'shared.buttons.back' | i18n }}</button>
        </ng-template>
        <button
          type="button"
          class="btn-primary"
          [disabled]="isInvoiceUnavailableSelectionBlocked"
          (click)="saveAndContinue()"
        >
          {{ (isLastStep ? 'shared.buttons.save' : 'shared.buttons.continue') | i18n }}
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="!isPlanPayment; else contentOnly">
  <umkt-card-wrapper
    [title]="'pages.paymentMethod.title' | i18n"
    [icon]="{ name: 'pagamento-digital', type: 'mondrian-icons' }"
    [showCheck]="true"
    [loading]="isLoading"
    [loadingText]="'shared.messages.processing' | i18n"
    [initiallyOpen]="initiallyOpen"
    [disabled]="disabled"
  >
    <ng-container *ngTemplateOutlet="paymentMethodContent"></ng-container>
  </umkt-card-wrapper>
</ng-container>

<ng-template #contentOnly>
  <ng-container *ngTemplateOutlet="paymentMethodContent"></ng-container>
  <umkt-loading [isLoading]="isLoading"></umkt-loading>
</ng-template>